import { apiSlice } from '../../../store/api/apiSlice';

export interface AdminUserViewState {
  id: string;
  person_id: string;
  key: string;
  dismissed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface AdminListUserViewStatesResponse {
  items: AdminUserViewState[];
  total: number;
  page: number;
  per: number;
}

export type AdminListUserViewStatesRequest = {
  personId: string;
  q?: string;
  dismissed?: boolean;
  page?: number;
  per?: number;
};

export const dismissableViewsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    adminListUserViewStates: builder.query<
      AdminListUserViewStatesResponse,
      AdminListUserViewStatesRequest
    >({
      query: ({ personId, q, dismissed, page, per }) => ({
        url: '/admin/ui/view-states',
        params: {
          person_id: personId,
          ...(q ? { q } : {}),
          ...(dismissed === true ? { dismissed: 'true' } : {}),
          ...(dismissed === false ? { dismissed: 'false' } : {}),
          ...(page ? { page } : {}),
          ...(per ? { per } : {}),
        },
      }),
      providesTags: (_result, _err, arg) => [
        { type: 'AdminUserViewStates' as const, id: arg.personId },
      ],
    }),

    adminResetUserViewState: builder.mutation<
      { item: AdminUserViewState },
      { personId: string; id: string }
    >({
      query: ({ id }) => ({
        url: `/admin/ui/view-states/${encodeURIComponent(id)}:reset`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _err, arg) => [
        { type: 'AdminUserViewStates' as const, id: arg.personId },
      ],
    }),

    adminDismissUserViewState: builder.mutation<
      { item: AdminUserViewState },
      { personId: string; id: string }
    >({
      query: ({ id }) => ({
        url: `/admin/ui/view-states/${encodeURIComponent(id)}:dismiss`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _err, arg) => [
        { type: 'AdminUserViewStates' as const, id: arg.personId },
      ],
    }),

    adminDeleteUserViewState: builder.mutation<
      { ok: boolean; deleted: boolean },
      { personId: string; id: string }
    >({
      query: ({ id }) => ({
        url: `/admin/ui/view-states/${encodeURIComponent(id)}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _err, arg) => [
        { type: 'AdminUserViewStates' as const, id: arg.personId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAdminListUserViewStatesQuery,
  useAdminResetUserViewStateMutation,
  useAdminDismissUserViewStateMutation,
  useAdminDeleteUserViewStateMutation,
} = dismissableViewsApi;
